export const ACCOUNTING_BASE_PATH = '/accounting';
